export default __webpack_public_path__ + "static/video-poster-d087c751896e9b05878b6da5f3637ba6.webp";